var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.918,
    height: 11.038,
    viewBox: "0 0 18.918 11.038",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "dashboard",
    transform: "translate(-30.011 -224)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_179",
    "data-name": "Path 179",
    d: "M474.408,825.882l-1.033-3.128-1.033,3.158h-6.847c.413-4.427,3.778-7.88,7.88-7.88s7.467,3.453,7.88,7.88h-6.847Zm-1.033-9.444c-5.194,0-9.444,4.574-9.444,10.241a.759.759,0,0,0,.8.8h17.324a.76.76,0,0,0,.8-.8C482.819,821.012,478.569,816.438,473.375,816.438Z",
    transform: "translate(-433.92 -592.438)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_180",
    "data-name": "Path 180",
    d: "M473.375,818.8a.76.76,0,0,0-.8.8v.8a.8.8,0,0,0,1.594,0v-.8A.76.76,0,0,0,473.375,818.8Z",
    transform: "translate(-433.92 -592.438)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_181",
    "data-name": "Path 181",
    d: "M477.773,821.1l-.472.472a.733.733,0,0,0,0,1.092.752.752,0,0,0,.56.236.8.8,0,0,0,.561-.236l.472-.472a.733.733,0,0,0,0-1.092A.766.766,0,0,0,477.773,821.1Z",
    transform: "translate(-433.92 -592.438)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_182",
    "data-name": "Path 182",
    d: "M469.037,821.1a.775.775,0,0,0-1.181,1l.473.473a.863.863,0,0,0,.56.236.933.933,0,0,0,.561-.236.822.822,0,0,0,.089-1.092Z",
    transform: "translate(-433.92 -592.438)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardIcon);
export default __webpack_public_path__ + "static/media/DashboardIcon.38f8e5ad0bb5da69dbd3d151bf263acc.svg";
export { ForwardRef as ReactComponent };